import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Grid, Box } from "@mui/material/";
import actions from "../../Store/actions";
import Assignments from "./Assignments";
import Details from "./Details";
import styles from "./styles";
import { strings } from "../../common/i18n";
import { helpers } from "../../common/lib";
import CircularProgress from "@mui/material/CircularProgress";
import NotFound from "../../common/components/NotFound";
import { logToSentry } from "../../config/Sentry";

/**
 * Audit Edit Component
 */
export default () => {
    const { audits } = useSelector((state) => state);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const params = useParams();

    useEffect(() => {
        const { auditId } = params;
        const fetchData = async () => {
            if (auditId)
                try {
                    if (audits.data.length < 1) {
                        dispatch(actions.audits.create.getRequest());
                    }
                    await Promise.all([
                        dispatch(actions.accounts.create.getRequest()),
                        dispatch(actions.locations.create.getRequest()),
                        dispatch(actions.userLocations.create.getRequest()),
                        dispatch(
                            actions.auditReview.create.getRequest(auditId)
                        ),
                        dispatch(actions.altAssets.create.getRequest(auditId))
                    ]);
                } catch (error) {
                    const errStr = error.toString();
                    console.error(errStr);
                    logToSentry("On loading edit screen:", { error });
                    dispatch(
                        actions.toast.create.error(
                            strings("errors.onLoadEditScreen")
                        )
                    );
                }
        };
        fetchData();
        dispatch(actions.assetSync.create.start());
        return () => {
            dispatch(actions.assetSync.create.stop());
        };
    }, []);

    useEffect(() => {
        (() => {
            if (audits.data.length > 0) {
                let audit = helpers.getListItemForId(audits, params.auditId);
                audit = Object.keys(audit).length > 0 ? audit : null;
                dispatch(actions.audits.create.itemSet(audit));
                setLoading(false);
            }
        })();
    }, [loading, audits.data]);

    /** If loading  */
    if (loading)
        return (
            <Box sx={styles.loadingStyle}>
                <CircularProgress />
            </Box>
        );
    /** If no audit is found display not found message */
    if (!loading && !audits.item)
        return <NotFound message={strings("messages.auditNotFound")} />;

    if (!loading)
        return (
            <Grid sx={styles.fullHeight} container>
                <Grid sx={styles.fullHeight} item xs={4}>
                    <Details loading={loading} />
                </Grid>
                <Grid sx={styles.fullHeight} item xs={8}>
                    {!loading && <Assignments loading={loading} />}
                </Grid>
            </Grid>
        );
};
